<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-1972-skate-rankings-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-1972-skate-rankings-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.53225806451613;"
    data-aspect-ratio="0.532"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-1972-skate-rankings-xs-img"
      class="g-skate-rankings-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/1972-skate-rankings-xs.jpg);"
      loading="lazy"
    ></div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-1972-skate-rankings-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.82258064516129;"
    data-aspect-ratio="0.823"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-1972-skate-rankings-sm-img"
      class="g-skate-rankings-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/1972-skate-rankings-sm.jpg);"
      loading="lazy"
    ></div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-1972-skate-rankings-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 1.29411764705883;"
    data-aspect-ratio="1.294"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-1972-skate-rankings-md-img"
      class="g-skate-rankings-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/1972-skate-rankings-md.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:4.4256%;margin-top:-8.6px;left:84.5315%;width:49px;"
    >
      <p class="g-pstyle0">Final</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:4.6216%;margin-top:-8.6px;left:1.3382%;width:62px;"
    >
      <p class="g-pstyle0">Figures</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:4.6216%;margin-top:-8.6px;left:41.9442%;width:75px;"
    >
      <p class="g-pstyle0">Freeskate</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:7.955%;margin-top:-8.6px;left:46.2669%;width:26px;"
    >
      <p class="g-pstyle1">1</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:9.1314%;margin-top:-8.6px;left:1.4184%;width:26px;"
    >
      <p class="g-pstyle2">1</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:9.1314%;margin-top:-8.6px;left:1.4184%;width:26px;"
    >
      <p class="g-pstyle3">1</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:9.1314%;margin-top:-8.6px;left:1.4184%;width:26px;"
    >
      <p class="g-pstyle1">1</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:9.1314%;margin-top:-8.6px;left:88.5392%;width:26px;"
    >
      <p class="g-pstyle4">1</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:9.1314%;margin-top:-8.6px;left:89.5998%;width:90px;"
    >
      <p class="g-pstyle5">Trixi Schuba</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:12.4648%;margin-top:-8.6px;left:46.4184%;width:29px;"
    >
      <p class="g-pstyle6">2</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:13.8373%;margin-top:-8.6px;left:1.4184%;width:29px;"
    >
      <p class="g-pstyle2">2</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-text g-aiAbs g-aiPointText"
      style="top:13.8373%;margin-top:-8.6px;left:1.4184%;width:29px;"
    >
      <p class="g-pstyle6">2</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-text g-aiAbs g-aiPointText"
      style="top:13.8373%;margin-top:-8.6px;left:1.4184%;width:29px;"
    >
      <p class="g-pstyle3">2</p>
    </div>
    <div
      id="g-ai2-14"
      class="g-text g-aiAbs g-aiPointText"
      style="top:14.4256%;margin-top:-8.6px;left:88.2361%;width:29px;"
    >
      <p class="g-pstyle7">2</p>
    </div>
    <div
      id="g-ai2-15"
      class="g-text g-aiAbs g-aiPointText"
      style="top:18.7393%;margin-top:-8.6px;left:1.4184%;width:29px;"
    >
      <p class="g-pstyle2">3</p>
    </div>
    <div
      id="g-ai2-16"
      class="g-text g-aiAbs g-aiPointText"
      style="top:18.7393%;margin-top:-8.6px;left:90.2058%;width:82px;"
    >
      <p class="g-pstyle5">Janet Lynn</p>
    </div>
    <div
      id="g-ai2-17"
      class="g-text g-aiAbs g-aiPointText"
      style="top:18.7393%;margin-top:-8.6px;left:1.4184%;width:29px;"
    >
      <p class="g-pstyle7">3</p>
    </div>
    <div
      id="g-ai2-18"
      class="g-text g-aiAbs g-aiPointText"
      style="top:18.7393%;margin-top:-8.6px;left:1.4184%;width:29px;"
    >
      <p class="g-pstyle3">3</p>
    </div>
    <div
      id="g-ai2-19"
      class="g-text g-aiAbs g-aiPointText"
      style="top:18.9354%;margin-top:-8.6px;left:88.3876%;width:29px;"
    >
      <p class="g-pstyle8">3</p>
    </div>
    <div
      id="g-ai2-20"
      class="g-text g-aiAbs g-aiPointText"
      style="top:23.6412%;margin-top:-8.6px;left:1.4184%;width:29px;"
    >
      <p class="g-pstyle2">4</p>
    </div>
    <div
      id="g-ai2-21"
      class="g-text g-aiAbs g-aiPointText"
      style="top:23.6412%;margin-top:-8.6px;left:1.4184%;width:29px;"
    >
      <p class="g-pstyle3">4</p>
    </div>
    <div
      id="g-ai2-22"
      class="g-text g-aiAbs g-aiPointText"
      style="top:23.6412%;margin-top:-8.6px;left:1.4184%;width:29px;"
    >
      <p class="g-pstyle8">4</p>
    </div>
    <div
      id="g-ai2-23"
      class="g-text g-aiAbs g-aiPointText"
      style="top:24.8177%;margin-top:-8.6px;left:88.2361%;width:29px;"
    >
      <p class="g-pstyle6">4</p>
    </div>
    <div
      id="g-ai2-24"
      class="g-text g-aiAbs g-aiPointText"
      style="top:28.5432%;margin-top:-8.6px;left:1.4184%;width:29px;"
    >
      <p class="g-pstyle2">5</p>
    </div>
    <div
      id="g-ai2-25"
      class="g-text g-aiAbs g-aiPointText"
      style="top:28.5432%;margin-top:-8.6px;left:1.4184%;width:29px;"
    >
      <p class="g-pstyle3">5</p>
    </div>
    <div
      id="g-ai2-26"
      class="g-text g-aiAbs g-aiPointText"
      style="top:28.5432%;margin-top:-8.6px;left:1.4184%;width:29px;"
    >
      <p class="g-pstyle6">5</p>
    </div>
    <div
      id="g-ai2-27"
      class="g-text g-aiAbs g-aiPointText"
      style="top:28.9354%;margin-top:-8.6px;left:88.2361%;width:29px;"
    >
      <p class="g-pstyle6">5</p>
    </div>
    <div
      id="g-ai2-28"
      class="g-text g-aiAbs g-aiPointText"
      style="top:33.4452%;margin-top:-8.6px;left:1.4184%;width:29px;"
    >
      <p class="g-pstyle2">6</p>
    </div>
    <div
      id="g-ai2-29"
      class="g-text g-aiAbs g-aiPointText"
      style="top:33.4452%;margin-top:-8.6px;left:1.4184%;width:29px;"
    >
      <p class="g-pstyle3">6</p>
    </div>
    <div
      id="g-ai2-30"
      class="g-text g-aiAbs g-aiPointText"
      style="top:33.4452%;margin-top:-8.6px;left:1.4184%;width:29px;"
    >
      <p class="g-pstyle6">6</p>
    </div>
    <div
      id="g-ai2-31"
      class="g-text g-aiAbs g-aiPointText"
      style="top:33.8373%;margin-top:-8.6px;left:88.2361%;width:29px;"
    >
      <p class="g-pstyle6">6</p>
    </div>
    <div
      id="g-ai2-32"
      class="g-text g-aiAbs g-aiPointText"
      style="top:37.1706%;margin-top:-8.6px;left:46.4184%;width:28px;"
    >
      <p class="g-pstyle6">7</p>
    </div>
    <div
      id="g-ai2-33"
      class="g-text g-aiAbs g-aiPointText"
      style="top:38.3471%;margin-top:-8.6px;left:1.4184%;width:28px;"
    >
      <p class="g-pstyle2">7</p>
    </div>
    <div
      id="g-ai2-34"
      class="g-text g-aiAbs g-aiPointText"
      style="top:38.3471%;margin-top:-8.6px;left:1.4184%;width:28px;"
    >
      <p class="g-pstyle3">7</p>
    </div>
    <div
      id="g-ai2-35"
      class="g-text g-aiAbs g-aiPointText"
      style="top:38.3471%;margin-top:-8.6px;left:1.4184%;width:28px;"
    >
      <p class="g-pstyle6">7</p>
    </div>
    <div
      id="g-ai2-36"
      class="g-text g-aiAbs g-aiPointText"
      style="top:38.7393%;margin-top:-8.6px;left:88.2361%;width:28px;"
    >
      <p class="g-pstyle6">7</p>
    </div>
    <div
      id="g-ai2-37"
      class="g-text g-aiAbs g-aiPointText"
      style="top:43.2491%;margin-top:-8.6px;left:1.4184%;width:29px;"
    >
      <p class="g-pstyle2">8</p>
    </div>
    <div
      id="g-ai2-38"
      class="g-text g-aiAbs g-aiPointText"
      style="top:43.2491%;margin-top:-8.6px;left:1.4184%;width:29px;"
    >
      <p class="g-pstyle3">8</p>
    </div>
    <div
      id="g-ai2-39"
      class="g-text g-aiAbs g-aiPointText"
      style="top:43.2491%;margin-top:-8.6px;left:1.4184%;width:29px;"
    >
      <p class="g-pstyle6">8</p>
    </div>
    <div
      id="g-ai2-40"
      class="g-text g-aiAbs g-aiPointText"
      style="top:43.6412%;margin-top:-8.6px;left:88.2361%;width:29px;"
    >
      <p class="g-pstyle6">8</p>
    </div>
    <div
      id="g-ai2-41"
      class="g-text g-aiAbs g-aiPointText"
      style="top:48.151%;margin-top:-8.6px;left:1.4184%;width:29px;"
    >
      <p class="g-pstyle2">9</p>
    </div>
    <div
      id="g-ai2-42"
      class="g-text g-aiAbs g-aiPointText"
      style="top:48.151%;margin-top:-8.6px;left:1.4184%;width:29px;"
    >
      <p class="g-pstyle3">9</p>
    </div>
    <div
      id="g-ai2-43"
      class="g-text g-aiAbs g-aiPointText"
      style="top:48.151%;margin-top:-8.6px;left:1.4184%;width:29px;"
    >
      <p class="g-pstyle6">9</p>
    </div>
    <div
      id="g-ai2-44"
      class="g-text g-aiAbs g-aiPointText"
      style="top:48.3471%;margin-top:-8.6px;left:88.2361%;width:29px;"
    >
      <p class="g-pstyle6">9</p>
    </div>
    <div
      id="g-ai2-45"
      class="g-text g-aiAbs g-aiPointText"
      style="top:53.053%;margin-top:-8.6px;left:0.5519%;width:34px;"
    >
      <p class="g-pstyle2">10</p>
    </div>
    <div
      id="g-ai2-46"
      class="g-text g-aiAbs g-aiPointText"
      style="top:53.053%;margin-top:-8.6px;left:0.5519%;width:34px;"
    >
      <p class="g-pstyle3">10</p>
    </div>
    <div
      id="g-ai2-47"
      class="g-text g-aiAbs g-aiPointText"
      style="top:53.053%;margin-top:-8.6px;left:0.5519%;width:34px;"
    >
      <p class="g-pstyle6">10</p>
    </div>
    <div
      id="g-ai2-48"
      class="g-text g-aiAbs g-aiPointText"
      style="top:53.2491%;margin-top:-8.6px;left:88.2361%;width:34px;"
    >
      <p class="g-pstyle6">10</p>
    </div>
    <div
      id="g-ai2-49"
      class="g-text g-aiAbs g-aiPointText"
      style="top:57.955%;margin-top:-8.6px;left:0.5519%;width:31px;"
    >
      <p class="g-pstyle2">11</p>
    </div>
    <div
      id="g-ai2-50"
      class="g-text g-aiAbs g-aiPointText"
      style="top:57.955%;margin-top:-8.6px;left:0.5519%;width:31px;"
    >
      <p class="g-pstyle3">11</p>
    </div>
    <div
      id="g-ai2-51"
      class="g-text g-aiAbs g-aiPointText"
      style="top:57.955%;margin-top:-8.6px;left:0.5519%;width:31px;"
    >
      <p class="g-pstyle6">11</p>
    </div>
    <div
      id="g-ai2-52"
      class="g-text g-aiAbs g-aiPointText"
      style="top:58.151%;margin-top:-8.6px;left:88.2361%;width:31px;"
    >
      <p class="g-pstyle6">11</p>
    </div>
    <div
      id="g-ai2-53"
      class="g-text g-aiAbs g-aiPointText"
      style="top:62.6608%;margin-top:-8.6px;left:0.5519%;width:33px;"
    >
      <p class="g-pstyle2">12</p>
    </div>
    <div
      id="g-ai2-54"
      class="g-text g-aiAbs g-aiPointText"
      style="top:62.6608%;margin-top:-8.6px;left:0.5519%;width:33px;"
    >
      <p class="g-pstyle3">12</p>
    </div>
    <div
      id="g-ai2-55"
      class="g-text g-aiAbs g-aiPointText"
      style="top:62.6608%;margin-top:-8.6px;left:0.5519%;width:33px;"
    >
      <p class="g-pstyle6">12</p>
    </div>
    <div
      id="g-ai2-56"
      class="g-text g-aiAbs g-aiPointText"
      style="top:63.053%;margin-top:-8.6px;left:88.2361%;width:33px;"
    >
      <p class="g-pstyle6">12</p>
    </div>
    <div
      id="g-ai2-57"
      class="g-text g-aiAbs g-aiPointText"
      style="top:67.5628%;margin-top:-8.6px;left:0.5519%;width:33px;"
    >
      <p class="g-pstyle2">13</p>
    </div>
    <div
      id="g-ai2-58"
      class="g-text g-aiAbs g-aiPointText"
      style="top:67.5628%;margin-top:-8.6px;left:0.5519%;width:33px;"
    >
      <p class="g-pstyle3">13</p>
    </div>
    <div
      id="g-ai2-59"
      class="g-text g-aiAbs g-aiPointText"
      style="top:67.5628%;margin-top:-8.6px;left:0.5519%;width:33px;"
    >
      <p class="g-pstyle6">13</p>
    </div>
    <div
      id="g-ai2-60"
      class="g-text g-aiAbs g-aiPointText"
      style="top:67.955%;margin-top:-8.6px;left:88.2361%;width:33px;"
    >
      <p class="g-pstyle6">13</p>
    </div>
    <div
      id="g-ai2-61"
      class="g-text g-aiAbs g-aiPointText"
      style="top:72.4648%;margin-top:-8.6px;left:0.5519%;width:34px;"
    >
      <p class="g-pstyle2">14</p>
    </div>
    <div
      id="g-ai2-62"
      class="g-text g-aiAbs g-aiPointText"
      style="top:72.4648%;margin-top:-8.6px;left:0.5519%;width:34px;"
    >
      <p class="g-pstyle6">14</p>
    </div>
    <div
      id="g-ai2-63"
      class="g-text g-aiAbs g-aiPointText"
      style="top:72.4648%;margin-top:-8.6px;left:0.5519%;width:34px;"
    >
      <p class="g-pstyle3">14</p>
    </div>
    <div
      id="g-ai2-64"
      class="g-text g-aiAbs g-aiPointText"
      style="top:72.8569%;margin-top:-8.6px;left:88.2361%;width:34px;"
    >
      <p class="g-pstyle6">14</p>
    </div>
    <div
      id="g-ai2-65"
      class="g-text g-aiAbs g-aiPointText"
      style="top:77.3667%;margin-top:-8.6px;left:0.5519%;width:34px;"
    >
      <p class="g-pstyle2">15</p>
    </div>
    <div
      id="g-ai2-66"
      class="g-text g-aiAbs g-aiPointText"
      style="top:77.3667%;margin-top:-8.6px;left:0.5519%;width:34px;"
    >
      <p class="g-pstyle6">15</p>
    </div>
    <div
      id="g-ai2-67"
      class="g-text g-aiAbs g-aiPointText"
      style="top:77.3667%;margin-top:-8.6px;left:0.5519%;width:34px;"
    >
      <p class="g-pstyle3">15</p>
    </div>
    <div
      id="g-ai2-68"
      class="g-text g-aiAbs g-aiPointText"
      style="top:77.7589%;margin-top:-8.6px;left:88.2361%;width:34px;"
    >
      <p class="g-pstyle6">15</p>
    </div>
    <div
      id="g-ai2-69"
      class="g-text g-aiAbs g-aiPointText"
      style="top:82.2687%;margin-top:-8.6px;left:0.5519%;width:34px;"
    >
      <p class="g-pstyle2">16</p>
    </div>
    <div
      id="g-ai2-70"
      class="g-text g-aiAbs g-aiPointText"
      style="top:82.2687%;margin-top:-8.6px;left:0.5519%;width:34px;"
    >
      <p class="g-pstyle6">16</p>
    </div>
    <div
      id="g-ai2-71"
      class="g-text g-aiAbs g-aiPointText"
      style="top:82.2687%;margin-top:-8.6px;left:0.5519%;width:34px;"
    >
      <p class="g-pstyle3">16</p>
    </div>
    <div
      id="g-ai2-72"
      class="g-text g-aiAbs g-aiPointText"
      style="top:82.6608%;margin-top:-8.6px;left:88.2361%;width:34px;"
    >
      <p class="g-pstyle6">16</p>
    </div>
    <div
      id="g-ai2-73"
      class="g-text g-aiAbs g-aiPointText"
      style="top:87.1706%;margin-top:-8.6px;left:0.5519%;width:33px;"
    >
      <p class="g-pstyle2">17</p>
    </div>
    <div
      id="g-ai2-74"
      class="g-text g-aiAbs g-aiPointText"
      style="top:87.1706%;margin-top:-8.6px;left:0.5519%;width:33px;"
    >
      <p class="g-pstyle6">17</p>
    </div>
    <div
      id="g-ai2-75"
      class="g-text g-aiAbs g-aiPointText"
      style="top:87.1706%;margin-top:-8.6px;left:0.5519%;width:33px;"
    >
      <p class="g-pstyle3">17</p>
    </div>
    <div
      id="g-ai2-76"
      class="g-text g-aiAbs g-aiPointText"
      style="top:87.5628%;margin-top:-8.6px;left:88.2361%;width:33px;"
    >
      <p class="g-pstyle6">17</p>
    </div>
    <div
      id="g-ai2-77"
      class="g-text g-aiAbs g-aiPointText"
      style="top:92.0726%;margin-top:-8.6px;left:0.5519%;width:34px;"
    >
      <p class="g-pstyle2">18</p>
    </div>
    <div
      id="g-ai2-78"
      class="g-text g-aiAbs g-aiPointText"
      style="top:92.0726%;margin-top:-8.6px;left:0.5519%;width:34px;"
    >
      <p class="g-pstyle3">18</p>
    </div>
    <div
      id="g-ai2-79"
      class="g-text g-aiAbs g-aiPointText"
      style="top:92.0726%;margin-top:-8.6px;left:0.5519%;width:34px;"
    >
      <p class="g-pstyle6">18</p>
    </div>
    <div
      id="g-ai2-80"
      class="g-text g-aiAbs g-aiPointText"
      style="top:92.4648%;margin-top:-8.6px;left:88.2361%;width:34px;"
    >
      <p class="g-pstyle6">18</p>
    </div>
    <div
      id="g-ai2-81"
      class="g-text g-aiAbs g-aiPointText"
      style="top:96.9746%;margin-top:-8.6px;left:0.5519%;width:34px;"
    >
      <p class="g-pstyle2">19</p>
    </div>
    <div
      id="g-ai2-82"
      class="g-text g-aiAbs g-aiPointText"
      style="top:96.9746%;margin-top:-8.6px;left:0.5519%;width:34px;"
    >
      <p class="g-pstyle3">19</p>
    </div>
    <div
      id="g-ai2-83"
      class="g-text g-aiAbs g-aiPointText"
      style="top:96.9746%;margin-top:-8.6px;left:0.5519%;width:34px;"
    >
      <p class="g-pstyle6">19</p>
    </div>
    <div
      id="g-ai2-84"
      class="g-text g-aiAbs g-aiPointText"
      style="top:97.1706%;margin-top:-8.6px;left:88.2361%;width:34px;"
    >
      <p class="g-pstyle6">19</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-1972-skate-rankings-lg"
    class="g-artboard"
    style="min-width: 930px;max-width: 1199px;aspect-ratio: 1.5;"
    data-aspect-ratio="1.5"
    data-min-width="930"
    data-max-width="1199"
  >
    <div
      id="g-1972-skate-rankings-lg-img"
      class="g-skate-rankings-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/1972-skate-rankings-lg.jpg);"
      loading="lazy"
    ></div>
  </div>
  <!-- Artboard: xl -->
  <div
    id="g-1972-skate-rankings-xl"
    class="g-artboard"
    style="min-width: 1200px;aspect-ratio: 1.93548387096774;"
    data-aspect-ratio="1.935"
    data-min-width="1200"
  >
    <div
      id="g-1972-skate-rankings-xl-img"
      class="g-skate-rankings-xl-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/1972-skate-rankings-xl.jpg);"
      loading="lazy"
    ></div>
  </div>
</div>

<!-- End ai2svelte - 2026-01-06 16:03 -->

<!-- Generated by ai2svelte v0.123.1 - 2026-01-06 16:03 -->
<!-- ai file: 1972-skate-rankings.ai -->
<style lang="scss">
  #g-1972-skate-rankings-box {
    container-type: inline-size;
    container-name: g-1972-skate-rankings-box;
  }
  #g-1972-skate-rankings-box,
  #g-1972-skate-rankings-box .g-artboard {
    margin: 0 auto;
  }
  #g-1972-skate-rankings-box p {
    margin: 0;
  }
  #g-1972-skate-rankings-box .g-aiAbs {
    position: absolute;
  }
  #g-1972-skate-rankings-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-1972-skate-rankings-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-1972-skate-rankings-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-1972-skate-rankings-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-1972-skate-rankings-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-1972-skate-rankings-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-1972-skate-rankings-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-1972-skate-rankings-md {
        display: block !important;
      }
    }
    @container (min-width:930px) and (max-width: 1199px) {
      #g-1972-skate-rankings-lg {
        display: block !important;
      }
    }
    @container (min-width:1200px) {
      #g-1972-skate-rankings-xl {
        display: block !important;
      }
    }
  }
  #g-1972-skate-rankings-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-1972-skate-rankings-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-1972-skate-rankings-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-1972-skate-rankings-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 13px;
    text-align: left;
    color: rgb(119, 119, 119);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-1972-skate-rankings-md .g-pstyle0 {
    font-weight: 400;
    height: 16px;
    color: rgb(123, 123, 123);
  }
  #g-1972-skate-rankings-md .g-pstyle1 {
    font-weight: 400;
    height: 16px;
    color: rgb(156, 110, 0);
  }
  #g-1972-skate-rankings-md .g-pstyle2 {
    font-weight: 400;
    height: 16px;
    color: rgb(0, 255, 0);
  }
  #g-1972-skate-rankings-md .g-pstyle3 {
    font-weight: 400;
    height: 16px;
    color: rgb(0, 0, 0);
  }
  #g-1972-skate-rankings-md .g-pstyle4 {
    font-weight: 400;
    height: 16px;
    color: rgb(253, 194, 24);
  }
  #g-1972-skate-rankings-md .g-pstyle5 {
    font-weight: 500;
    height: 16px;
    color: rgb(102, 102, 102);
  }
  #g-1972-skate-rankings-md .g-pstyle6 {
    font-weight: 400;
    height: 16px;
  }
  #g-1972-skate-rankings-md .g-pstyle7 {
    font-weight: 400;
    height: 16px;
    color: rgb(114, 114, 114);
  }
  #g-1972-skate-rankings-md .g-pstyle8 {
    font-weight: 400;
    height: 16px;
    color: rgb(188, 82, 37);
  }
  #g-1972-skate-rankings-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-1972-skate-rankings-xl {
    position: relative;
    overflow: hidden;
    display: none;
  }

  /* Custom CSS */
</style>
